module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-13-bf209a03f00086ecc4040fb15fe43585.jpg";